// Base URL of the HyperFrames service.
//
// Empty (default): the service is reached through the same origin under the
// `/hyperframes` prefix (docker compose / self-hosted nginx proxies it).
//
// When the editor is served from a different origin (e.g. Cloudflare Pages),
// set VITE_APP_HYPERFRAMES_URL=https://<hyperframes-domain> at build time.
const RAW_BASE = (process.env.VITE_APP_HYPERFRAMES_URL || "").replace(/\/+$/, "")

/** API calls (`/agent/*`, `/compose/*`, `/render/*`). */
export const hfApiUrl = (path: string): string =>
  RAW_BASE ? `${RAW_BASE}${path}` : `/hyperframes${path}`

/** Pages served by the service itself (`/preview`, `/watch`, `/raw`, `/files`). */
export const hfPageUrl = (path: string): string => (RAW_BASE ? `${RAW_BASE}${path}` : path)

/** Resolve a URL returned by the service (previewUrl/watchUrl are relative). */
export const hfResolve = (url: string): string => (url.startsWith("http") ? url : hfPageUrl(url))
